import { reactive, computed } from 'vue'
import { getOverdueOrderSummary } from '@/api/billWarning'
import { numberUtils } from '@/utils/number'

export function useBillSummary() {
  const summary = reactive({
    totalReceivableAmount: 0,
    totalReceivedAmount: 0,
    totalOverdueAmount: 0,
    overdueCarCount: 0,
  })

  const cards = computed(() => [
    {
      key: 'receivable',
      title: '应收金额',
      value: `¥${numberUtils.format(summary.totalReceivableAmount)}`,
      cardClass: 'card-blue',
    },
    {
      key: 'received',
      title: '实收金额',
      value: `¥${numberUtils.format(summary.totalReceivedAmount)}`,
      cardClass: 'card-green',
    },
    {
      key: 'overdue',
      title: '逾期金额',
      value: `¥${numberUtils.format(summary.totalOverdueAmount)}`,
      cardClass: 'card-orange',
    },
    {
      key: 'count',
      title: '逾期车辆数',
      value: `${summary.overdueCarCount || 0}`,
      cardClass: 'card-red',
    },
  ])

  async function reloadSummary(params = {}) {
    const { code, data } = await getOverdueOrderSummary(params)
    if (code === 1 && data) Object.assign(summary, data)
  }

  return { summary, cards, reloadSummary }
}
